export default function blurNumberInputOnWheel(): void {
  // Only Chromium-based browsers change the value of a focused number input on wheel.
  // Firefox and Safari ignore wheel events on number inputs, so the listener is not needed there.
  if (!/(Chrome|CriOS)\//.test(navigator.userAgent)) {
    return;
  }

  document.addEventListener(
    'wheel',
    (event) => {
      const activeElement = document.activeElement;

      if (
        activeElement instanceof HTMLInputElement &&
        activeElement.type === 'number' &&
        activeElement === event.target
      ) {
        activeElement.blur();
      }
    },
    { passive: true },
  );
}
